import { Box, Modal, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import LockIcon from '../assets/SVG/lockIcon';
import TrackpadDeactiveIcon from '../assets/SVG/trackpadDeactiveIcon';
import InputLoginForm from './login/inputLoginForm';

export default function DeactivationGroup({show,setShow}) {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
      setShow(false);
      setOpen(false);
    };
    useEffect(() => {
      if (show === true) {
        setOpen(true);
      }
    }, [show]);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      //   sx={{}}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 420,
          height: 380,
          bgcolor: "white",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
          ":focus-visible": {
            outline: "none !important",
            border: "none !important",
          },
        }}
      >
        <Box width='fit-content' margin='auto' >
            <TrackpadDeactiveIcon />
        </Box>
        <Typography mb='30px' fontSize='22px' textAlign='center' >{'غیرفعال سازی'}</Typography>
        <InputLoginForm lable="رمز عبور" placeholder={"رمز عبور"}>
        <LockIcon />
      </InputLoginForm>
      <Typography fontSize={'17px'} color='#787878' mt='20px' >{'بعد از تأیید این گروه، به طور موقت غیرفعال می‌شود و می‌توانید پس از یک روز آن را دوباره فعال کنید.'}</Typography>
      <Box display='flex' alignItems='center' justifyContent='center' mt='50px' >

      <button style={{backgroundColor:'white',width:'163px',height:'43px',borderRadius:'7px',border:'none',color:'#126E83',fontSize:'22px'}} onClick={handleClose} >انصراف</button>
      <button style={{backgroundColor:'#F05542',width:'163px',height:'43px',borderRadius:'7px',border:'none',color:'white',fontSize:'22px'}} >تایید</button>
      </Box>
      </Box>
      </Modal>
  )
}
